import APIClient from "../apiClient/_baseClasses";

const apiClient = new APIClient({
  basePath: process.env.VUE_APP_API_URL,
});

export default apiClient;